<!-- 
// +----------------------------------------------------------------------
// | LightPicture [ 图床 ]
// +----------------------------------------------------------------------
// | 企业团队图片资源管理系统
// +----------------------------------------------------------------------
// | Github: https://github.com/osuuu/LightPicture
// +----------------------------------------------------------------------
// | Copyright © http://picture.h234.cn All rights reserved.
// +----------------------------------------------------------------------
// | Author: Team <admin@osuu.net>
// +---------------------------------------------------------------------- 
-->
<template>
  <div :class="$store.state.isMenu ? 'enable-vertical-menu' : ''">
    <div id="layout-wrapper">
      <div class="vertical-menu mm-active">
        <div class="h-100">
          <div class="navbar-brand-box">
            <span class="brand-name">{{ $store.state.config.system_name || 'LightPicture' }}</span>
          </div>

          <div id="sidebar-menu">
            <!-- 左侧导航 -->
            <Menu :open-names="openItem" :active-name="activeName" accordion>
              <div v-for="item in menuItem" :key="item.path">
                <div v-if="item.meta.isShow">
                  <Submenu v-if="item.meta.isFold" :name="item.name">
                    <template slot="title">
                      <span :class="item.meta.icon"></span>
                      {{ item.meta.title }}
                    </template>
                    <MenuItem v-for="list in item.children" v-show="list.meta.isShow" :key="list.path" :name="list.name"
                      :to="'/' + item.path + '/' + list.path">
                    {{ list.meta.title }}
                    </MenuItem>
                  </Submenu>
                  <MenuItem v-else :name="item.name" :to="'/' + item.path">
                  <span :class="item.meta.icon"></span>
                  {{ item.meta.title }}
                  </MenuItem>
                </div>
              </div>
            </Menu>
          </div>

          <Capacity v-if="userInfo.capacity && !isMobile"></Capacity>

        </div>
      </div>

      <header id="page-topbar">
        <div class="navbar-header">
          <div class="d-flex align-items-left">
            <span class="osuu-net geek-caidan" @click="$store.state.isMenu = !$store.state.isMenu"></span>
            <!-- <div class="dropdown d-inline-block" @click="toGit">
              <Icon custom="osuu-net geek-github" size="26"></Icon>
            </div> -->
          </div>
          <!-- <div class="d-flex align-items-center" v-if="update">
            <div class="dropdown d-inline-block" @click="$router.push('/update')">
              <Tooltip content="版本更新" placement="bottom">
                <Icon custom="osuu-net geek-iconfontzhizuobiaozhun0254" size="26"></Icon>
              </Tooltip>
            </div>
          </div> -->

          <div class="d-flex align-items-center">

            <!-- 登录注册 -->
            <div class="dropdown d-inline-block" style="width:100px" @click="switchAccount(1)" v-if="!userInfo.avatar">
              <span style="font-size: 16px">登录/注册 </span>
            </div>
            <div class="d-flex align-items-center header-right" v-else>
              <!-- 通知 -->
              <Poptip trigger="click" transfer width="300" @on-popper-show="openNotice">
                <Badge :count="noticeCount" overflow-count="99">
                  <Icon type="ios-notifications-outline" size="24" style="cursor: pointer" />
                </Badge>
                <div slot="content">
                  <div class="notice-list">
                    <p class="notice-empty" v-if="noticeList.length == 0">暂无通知</p>
                    <div class="notice-item" v-for="n in noticeList" :key="n.id" @click="showNotice(n)">
                      <p class="notice-content">{{ n.content }}</p>
                      <p class="notice-time">{{ n.create_time }}</p>
                    </div>
                  </div>
                </div>
              </Poptip>
              <!-- 用户名 -->
              <span class="header-username">{{ userInfo.username }}</span>
              <!-- 头像（保留 dropdown 类，.dropdown .avatar 样式依赖它） -->
              <div class="dropdown d-inline-block" style="margin-left: 12px">
                <UserFloat></UserFloat>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
    <div class="menu-overlay" @click="$store.state.isMenu = false"></div>
    <!-- 通知详情 -->
    <Modal title="通知详情" v-model="noticeModal" class-name="vertical-center-modal" footer-hide>
      <p class="notice-detail-content">{{ noticeDetail.content }}</p>
      <p class="notice-detail-time">{{ noticeDetail.create_time }}</p>
    </Modal>
  </div>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from "vuex";
  import {
    getNotice,
    readNotice
  } from "@/api";
  export default {
    data() {
      return {
        menuItem: [],
        activeName: "",
        openItem: ["setup"],
        update: false,
        noticeCount: 0,
        noticeList: [],
        noticeTimer: null,
        noticeModal: false,
        noticeDetail: {}
      };
    },
    computed: {
      ...mapState(["isAccount", "userInfo", "config", "isMobile"]),
    },

    methods: {
      ...mapMutations(["switchAccount"]),
      toGit() {
        window.open('https://github.com/osuuu/LightPicture');
      },
      // 按登录状态/角色/系统配置控制侧边栏
      applyMenu() {
        if (!this.userInfo.role) {
          // 未登录：只显示首页、图库
          this.menuItem[2]['meta']['isShow'] = false;
          this.menuItem[3]['meta']['isShow'] = false;
          return;
        }
        // 登录后开始拉取通知，并每30秒刷新未读数
        if (this.userInfo.avatar && !this.noticeTimer) {
          this.getNoticeData();
          this.noticeTimer = setInterval(this.getNoticeData, 30000);
        }
        if (this.userInfo.role.is_admin == 1) {
          this.update = true
          this.menuItem[2]['meta']['isShow'] = true
          this.menuItem[3]['meta']['isShow'] = true
          this.menuItem[3]['children'][1]['meta']['isShow'] = true
          this.menuItem[3]['children'][2]['meta']['isShow'] = true
          this.menuItem[3]['children'][3]['meta']['isShow'] = true
          this.menuItem[3]['children'][4]['meta']['isShow'] = true
        } else {
          // 非管理员：接口按系统设置显隐，系统设置仅管理员
          this.menuItem[2]['meta']['isShow'] = this.config.is_show_word == 1
          this.menuItem[3]['meta']['isShow'] = true
          this.menuItem[3]['children'][1]['meta']['isShow'] = this.config.is_show_storage == 1
          this.menuItem[3]['children'][2]['meta']['isShow'] = this.config.is_show_role == 1
          this.menuItem[3]['children'][3]['meta']['isShow'] = this.config.is_show_member == 1
          this.menuItem[3]['children'][4]['meta']['isShow'] = false
        }
      },
      // 拉取通知（未读数+最近20条）
      getNoticeData() {
        getNotice().then((res) => {
          this.noticeCount = res.data.unread;
          this.noticeList = res.data.list;
        }).catch(() => {});
      },
      // 点开通知面板：刷新列表并全部标记已读
      openNotice() {
        getNotice().then((res) => {
          this.noticeList = res.data.list;
          this.noticeCount = res.data.unread;
          if (res.data.unread > 0) {
            readNotice().then(() => {
              this.noticeCount = 0;
            });
          }
        }).catch(() => {});
      },
      // 查看通知详情
      showNotice(n) {
        this.noticeDetail = n;
        this.noticeModal = true;
      },
    },
    created() {
      this.menuItem = this.$router.options.routes[0].children;
      this.activeName = this.$route.name;
      if (this.$route.name.indexOf("-") != -1) {
        this.openItem.push(this.$route.name.split("-")[0]);
      }
      // 进入布局时立即计算一次菜单显隐（sessionStorage 里的登录态已同步恢复，避免先全量展示再隐藏的闪烁）
      this.applyMenu();
    },
    beforeDestroy() {
      if (this.noticeTimer) clearInterval(this.noticeTimer);
    },
    watch: {
      // 监听路由刷新
      $route: {
        handler: function (val, oldVal) {
          if (this.isMobile) {
            this.$store.state.isMenu = false;
          }
        },
        // 深度观察监听
        deep: true,
      },
      userInfo: {
        handler: function (val, oldVal) {
          this.applyMenu();
        },
        // 深度观察监听
        deep: true,
      },
      config: {
        handler: function (val, oldVal) {
          this.applyMenu();
        },
        deep: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import url("../../assets/css/theme.min.css");
  @import url("../../assets/css/clean.css");
  @deep: ~">>>";

  @{deep}.ivu-dropdown,
  .ivu-icon {
    vertical-align: middle;
  }

  .align-items-left {
    width: 100%;
    height: 60px;
    // padding: 0 20px;
    text-align: center;
    line-height: 60px;

    span {
      width: 60px;
      font-size: 20px;
      vertical-align: middle;
    }
  }

  .header-right {
    height: 60px;

    .ivu-poptip,
    .ivu-poptip-rel {
      display: flex;
      align-items: center;
    }

    .header-username {
      display: flex;
      align-items: center;
      height: 60px;
      margin-left: 10px;
      font-size: 14px;
      color: #333;
      max-width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .badge-got {
    position: absolute;
    transform: translateX(-50%);
    transform-origin: 0 center;
    top: 12px;
    right: 5px;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    background: #ed4014;
    z-index: 10;
    box-shadow: 0 0 0 1px #fff;
  }

  .navbar-brand-box {
    width: 240px;
    margin-top: 10px;

    .brand-name {
      display: block;
      text-align: center;
      font-size: 22px;
      font-weight: 600;
      color: #2d8cf0;
      line-height: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 20px;
    }
  }

  .right {
    float: right;
    color: #ff5656;
  }

  .hot {
    color: #ff5656;
  }

  .right-btn .iconfont {
    vertical-align: middle;
  }

  .h-100 {
    min-height: 100vh;
    position: relative;

    .over {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }

  @{deep}.ivu-menu-light:after {
    width: 0;
  }

  .notice-list {
    max-height: 320px;
    overflow-y: auto;

    .notice-empty {
      text-align: center;
      color: #999;
      padding: 20px 0;
      font-size: 13px;
    }

    .notice-item {
      padding: 8px 4px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;

      &:hover {
        background: #f5f7fa;
      }

      &:last-child {
        border-bottom: none;
      }

      .notice-content {
        font-size: 13px;
        color: #333;
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .notice-time {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .notice-detail-content {
    font-size: 14px;
    color: #333;
    line-height: 1.8;
    word-break: break-all;
  }

  .notice-detail-time {
    margin-top: 12px;
    font-size: 12px;
    color: #999;
  }

  @{deep}.ivu-form-item-label {
    font-weight: 100;
    font-size: 14px;
  }
</style>